module.exports = __webpack_public_path__ + "app/principal/modals/modal-delete-perimeter-3GVMgpUa.html";